import { CorporateState } from '../../entity/corporate/corporateState';

export class CorporateAddress {
    line1: string
    line2: string
    line3: string
    landmark: string
    city: string
    state: CorporateState
    zipcode: string    

    constructor(line1: string, line2: string, line3: string, landmark: string, city: string, state: CorporateState, zipcode: string) {
        this.line1 = line1
        this.line2 = line2
        this.line3 = line3
        this.landmark = landmark
        this.city = city
        this.state = state
        this.zipcode = zipcode
    }
}